module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_13 (20).9625786.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_13 (20).mp4
// module id = 795
// module chunks = 1